/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the NewACESEnrollChapWaitlistDtlsResponse
 *
 * @class NewACESEnrollChapWaitlistDtlsResponse
 */
class NewACESEnrollChapWaitlistDtlsResponse {
  /**
   * Creates an instance of NewACESEnrollChapWaitlistDtlsResponse.
   * @param {*} json
   * @memberof NewACESEnrollChapWaitlistDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // string
      this.iegExecutionId = json.iegExecutionId;
    }
  }
}

/**
 * Models the ACESChapWaitlistCheckRespDlts
 *
 * @class ACESChapWaitlistCheckRespDlts
 */
class ACESChapWaitlistCheckRespDlts {
  /**
   * Creates an instance of ACESChapWaitlistCheckRespDlts.
   * @param {*} json
   * @memberof ACESChapWaitlistCheckRespDlts
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isWaitlistApplied = json.isWaitlistApplied;
    }
  }
}

/**
 * Models the ACESWaitlistFundAvailableResp
 *
 * @class ACESWaitlistFundAvailableResp
 */
class ACESWaitlistFundAvailableResp {
  /**
   * Creates an instance of ACESWaitlistFundAvailableResp.
   * @param {*} json
   * @memberof ACESWaitlistFundAvailableResp
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isFundAvailable = json.isFundAvailable;
    }
  }
}

/**
 * Models the NewACESWaitlistKey
 *
 * @class NewACESWaitlistKey
 */
class NewACESWaitlistKey {
  /**
   * Creates an instance of NewACESWaitlistKey.
   * @param {*} json
   * @memberof NewACESWaitlistKey
   */
  constructor(json = null) {
    if (json) {
      // string
      this.iegExecutionId = json.iegExecutionId;
    }
  }
}

/**
 * Models the NewACESWaitlistFormResponseDtlsResponse
 *
 * @class NewACESWaitlistFormResponseDtlsResponse
 */
class NewACESWaitlistFormResponseDtlsResponse {
  /**
   * Creates an instance of NewACESWaitlistFormResponseDtlsResponse.
   * @param {*} json
   * @memberof NewACESWaitlistFormResponseDtlsResponse
   */
  constructor(json = null) {
    if (json) {
      // boolean
      this.isWaitlistApplicationCreated = json.isWaitlistApplicationCreated;
    }
  }
}

export default {
  NewACESEnrollChapWaitlistDtlsResponse,

  ACESChapWaitlistCheckRespDlts,

  ACESWaitlistFundAvailableResp,

  NewACESWaitlistKey,

  NewACESWaitlistFormResponseDtlsResponse,
};
